import React, { FC, ReactElement, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

interface Props {
  currentUser: any
}

const BandeauFormalites: FC<Props> = ({ currentUser }) => {
  const [isHidden, setIsHidden] = useState(false)
  if (isHidden) return null

  const { siren, inpiData, companyCreation, microCompanyCreation, transfertSiege, microTransfertSiege } = currentUser
  if (companyCreation || microCompanyCreation || transfertSiege || microTransfertSiege) return null
  if (siren && (!inpiData || inpiData?.siege_address_score > 0.7)) return null // means the user already has transferred their siege to our address, or we don't have the info

  const wording = !!siren ? 'Transfert de siège gratuit' : 'Création gratuite'

  return (
    <div className="bg-blue flex items-center justify-center py-[6px] px-3 text-sm leading-[1.33] relative">
      <div>
        <img src="/assets/icons/icon-cross.svg" className="h-4 w-4 absolute right-2 top-2" onClick={() => setIsHidden(true)} />
        <span className="inline">{wording} de votre société dans l'onglet Formalités.</span>
        <span className="inline">
          <Link to="/mon-compte/formalites" onClick={() => setIsHidden(true)}>
            <button className="ml-2 text-white underline">
              Commencer
            </button>
          </Link>
        </span>
      </div>
    </div>
  )
}

export default BandeauFormalites